import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerContent: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center",
        maxWidth: "80%",
        textAlign: "center"
    },
    coverPhoto: {
        width: "100%",
        resizeMode: "cover",
        height: 250
    },
    leftButton: {
        position: "absolute",
        top: "50%",
        marginTop: -25,
        width: 50,
        height: 50,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10
    },
    rightButton: {
        position: "absolute",
        top: "50%",
        marginTop: -25,
        width: 50,
        height: 50,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10
    },
    backButton: {
        alignSelf: "flex-start"
    },
    flex1: {
        flex: 1
    },
    closeButton: {
        position: "absolute",
        zIndex: 20
    },
    carouselContainer: {
        justifyContent: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    galleryImage: {
        resizeMode: "cover",
        height: 200
    },
    modalOverlay: {
        justifyContent: "center"
    }
});
export default stylesheet;
